import React from "react";
import { connect } from "react-redux";
import Typo from "@material-ui/core/Typography";
import { LinearProgress } from "@material-ui/core";

import enfj from "../../assets/mbti/enfj.png";
import enfp from "../../assets/mbti/enfp.png";
import entj from "../../assets/mbti/entj.png";
import entp from "../../assets/mbti/entp.png";
import esfj from "../../assets/mbti/esfj.png";
import esfp from "../../assets/mbti/esfp.png";
import estj from "../../assets/mbti/estj.png";
import estp from "../../assets/mbti/estp.png";
import intj from "../../assets/mbti/intj.png";
import infj from "../../assets/mbti/infj.png";
import infp from "../../assets/mbti/infp.png";
import intp from "../../assets/mbti/intp.png";
import isfj from "../../assets/mbti/isfj.png";
import isfp from "../../assets/mbti/isfp.png";
import istj from "../../assets/mbti/istj.png";
import istp from "../../assets/mbti/istp.png";
import MbtiComponent from "../../components/MBTI";
import { Redirect } from "react-router";

export class MbtiResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invalid: false,
      personality: "esfp",
      firstSection: 0,
      secondSection: 0,
      thirdSection: 0,
      forthSection: 0,
    };
    this.state.personality = this.props.MBTI.Personality;
    if (!this.props.MBTI.Personality) {
      this.state.invalid = true;
      this.props.history.push("/mbti");
    }
  }
  #images = {
    enfj,
    enfp,
    entj,
    entp,
    esfj,
    esfp,
    estj,
    estp,
    intj,
    infj,
    infp,
    intp,
    isfj,
    isfp,
    istj,
    istp,
  };

  #names = {
    I: "درون گرا",
    E: "برون گرا",
    S: "حسی ",
    N: "شهودی ",
    F: "احساسی  ",
    T: "منطقی  ",
    J: "قضاوتی  ",
    P: "ادراکی ",
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        firstSection: this.props.MBTI.firstSection,
        secondSection: this.props.MBTI.secondSection,
        thirdSection: this.props.MBTI.thirdSection,
        forthSection: this.props.MBTI.forthSection,
      });
    });
  }

  render() {
    if (this.state.invalid) return <Redirect to="/mbti" />;
    return (
      <>
        <div className="row">
          <div className="col-12">
            <Typo
              align="center"
              variant="h5"
              className="font-weight-bold p-5 border-bottom"
            >
              نتیجه تست MBTI
            </Typo>
          </div>
          <div className="col-12 p-5 text-center">
            <div className="row">
              <div className="col-md-3 text-center">
                <img
                  src={this.#images[this.state.personality.toLowerCase()]}
                  alt=""
                  className=" raounded-lg "
                />
              </div>
              <div className="col-md-9">
                <div className="row p-3">
                  <div className="col-md-2 text-center">
                    {Math.floor(this.state.firstSection)}%{" "}
                    {this.#names[this.state.personality[0].toUpperCase()]}
                  </div>
                  <div className="col-md-10 pt-2">
                    <LinearProgress
                      variant="determinate"
                      value={parseInt(this.state.firstSection)}
                    />
                  </div>
                </div>
                <div className="row p-3">
                  <div className="col-md-2 text-center">
                    {Math.floor(this.state.secondSection)}%{" "}
                    {this.#names[this.state.personality[1].toUpperCase()]}
                  </div>
                  <div className="col-md-10 pt-2">
                    <LinearProgress
                      variant="determinate"
                      value={parseInt(this.state.secondSection)}
                    />
                  </div>
                </div>
                <div className="row p-3">
                  <div className="col-md-2 text-center">
                    {Math.floor(this.state.thirdSection)}%{" "}
                    {this.#names[this.state.personality[2].toUpperCase()]}
                  </div>
                  <div className="col-md-10 pt-2">
                    <LinearProgress
                      variant="determinate"
                      value={parseInt(this.state.thirdSection)}
                    />
                  </div>
                </div>
                <div className="row p-3">
                  <div className="col-md-2 text-center">
                    {Math.floor(this.state.forthSection)}%{" "}
                    {this.#names[this.state.personality[3].toUpperCase()]}
                  </div>
                  <div className="col-md-10 pt-2">
                    <LinearProgress
                      variant="determinate"
                      value={parseFloat(this.state.forthSection)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <Typo variant="h4" className="font-weight-bold p-5">
              شما یک فرد {this.state.personality.toUpperCase()} هستید
            </Typo>
          </div>
          <div className="col-12 p-3">
            <MbtiComponent name={this.state.personality} />
          </div>
        </div>
      </>
    );
  }
}

const mapSateToProps = (state) => ({ MBTI: state.MBTI });
export default connect(mapSateToProps)(MbtiResult);
